import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  FULL_WIDTH_GALLERY_CONTAINER_CONVERTER_TOKEN, FullWidthGalleryContainerConverter
} from './full-width-gallery-container.component.converter'
import {
  FULL_WIDTH_GALLERY_ITEM_CONVERTER_TOKEN, FullWidthGalleryItemConverter
} from './full-width-gallery-item/full-width-gallery-item.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        fullWidthGalleryFeature: {
          module: () => import('./full-width-gallery-container.module').then((m) => m.FullWidthGalleryContainerModule),
          cmsComponents: ['full_width_gallery_container']
        },
      }
    }),
    {
      provide: FULL_WIDTH_GALLERY_CONTAINER_CONVERTER_TOKEN,
      useExisting: FullWidthGalleryContainerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        full_width_gallery_container: FULL_WIDTH_GALLERY_CONTAINER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: FULL_WIDTH_GALLERY_ITEM_CONVERTER_TOKEN,
      useExisting: FullWidthGalleryItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        full_width_gallery_item: FULL_WIDTH_GALLERY_ITEM_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class FullWidthGalleryFeatureModule {}
